/**
 * @generated SignedSource<<57af5be957251f949c7d18d74c9e575d>>
 * @relayHash 1b2bc31ac42719bf8add4db3a6390b58
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 127d43e36b149ae142a2ec8732d260390b2cd6c7260cd15d254197587add32cb

import type { ConcreteRequest } from 'relay-runtime';
export type EditorPreferencesMutation$variables = {
  toolbarDockingInitialPosition: string;
};
export type EditorPreferencesMutation$data = {
  readonly updateUserPreferences: {
    readonly confluenceEditorSettings: {
      readonly toolbarDockingInitialPosition: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type EditorPreferencesMutation = {
  response: EditorPreferencesMutation$data;
  variables: EditorPreferencesMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "toolbarDockingInitialPosition"
  }
],
v1 = [
  {
    "args": [
      {
        "fields": [
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "toolbarDockingInitialPosition",
                "variableName": "toolbarDockingInitialPosition"
              }
            ],
            "kind": "ObjectValue",
            "name": "confluenceEditorSettingsInput"
          }
        ],
        "kind": "ObjectValue",
        "name": "userPreferences"
      }
    ],
    "concreteType": "UserPreferences",
    "kind": "LinkedField",
    "name": "updateUserPreferences",
    "plural": false,
    "selections": [
      {
        "concreteType": "ConfluenceEditorSettings",
        "kind": "LinkedField",
        "name": "confluenceEditorSettings",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "toolbarDockingInitialPosition"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "EditorPreferencesMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EditorPreferencesMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "1b2bc31ac42719bf8add4db3a6390b58",
    "id": "127d43e36b149ae142a2ec8732d260390b2cd6c7260cd15d254197587add32cb",
    "metadata": {},
    "name": "EditorPreferencesMutation",
    "operationKind": "mutation",
    "text": "mutation EditorPreferencesMutation($toolbarDockingInitialPosition:String!){updateUserPreferences(userPreferences:{confluenceEditorSettingsInput:{toolbarDockingInitialPosition:$toolbarDockingInitialPosition}}){confluenceEditorSettings{toolbarDockingInitialPosition}}}"
  }
};
})();

(node as any).hash = "37475c1d65dabe41f55ac97eba30ddfa";

export default node;
